import { render, staticRenderFns } from "./OsobaUmanjeniSatCreate.vue?vue&type=template&id=90676fa6&scoped=true&"
import script from "./OsobaUmanjeniSatCreate.vue?vue&type=script&lang=js&"
export * from "./OsobaUmanjeniSatCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90676fa6",
  null
  
)

export default component.exports